import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

var iconCategoryList = require('./icon-category-list.json');
var iconLetterList = require('./icon-letter-list.json');
var iconMap = require('./icon-map.json');

@Injectable()
export class IconService {

  constructor(
    private http: HttpClient,
  ) { }

  private iconMap = {};

  private unescape(str: string) {
    let result = str
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&#x2F;/g, '/');
    return result;
  }

  public getIconLetterList() {
    return iconLetterList;
  }

  public getIconCategoryList() {
    return iconCategoryList;
  }

  public getIcon(id: string, type: 'binnenvorm' | 'buitenvorm' | 'outline', svgAttributes: any, pathAttributes: any, backGroundAttributes?: any) {
    let icon = this.unescape(iconMap[id][type]);
    let svgAttributeString = _.map(svgAttributes, (value, key) => `${key}="${value}"`).join(' ');
    // console.log(svgAttributeString);
    let pathAttributeString = _.map(pathAttributes, (value, key) => `${key}="${value}"`).join(' ') + ' stroke-miterlimit="10"';
    let backGroundAttributeString = _.map(backGroundAttributes || { 'fill': 'none', 'stroke': 'none'}, (value, key) => `${key}="${value}"`).join(' ') + ' stroke-miterlimit="10"';
    // console.log(pathAttributeString);
    icon = icon.replace(/SVGATTRIBUTES/g, svgAttributeString);
    icon = icon.replace(/PATHATTRIBUTES/g, pathAttributeString);
    icon = icon.replace(/BACKGROUNDATTRIBUTES/g, backGroundAttributeString);
    let parser = new DOMParser();
    let xml = parser.parseFromString(icon, 'image/svg+xml').documentElement;
    let node = document.importNode(xml, true);
    // console.log(node);
    return () => node;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/icon.service.ts